import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-more-info-trigger.css';
import { EGDSMoreInfoTriggerAlignsArray, EGDSMoreInfoTriggerThemesArray, EGDSMoreInfoTriggerWeightsArray, EGDSMoreInfoTriggerSizesArray } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSMoreInfoTrigger extends React.PureComponent {
  static displayName = 'EGDSMoreInfoTrigger';
  static defaultProps = {
    size: EGDSMoreInfoTriggerSizesArray[EGDSMoreInfoTriggerSizesArray.indexOf('medium')],
    weight: EGDSMoreInfoTriggerWeightsArray[EGDSMoreInfoTriggerWeightsArray.indexOf('regular')],
    theme: EGDSMoreInfoTriggerThemesArray[EGDSMoreInfoTriggerThemesArray.indexOf('default')],
    align: EGDSMoreInfoTriggerAlignsArray[EGDSMoreInfoTriggerAlignsArray.indexOf('leading')]
  };
  render() {
    const {
      children,
      size,
      weight,
      domRef,
      theme,
      align,
      className,
      analytics,
      ...props
    } = this.props;
    const childrenArray = React.Children.toArray(children);
    let firstChild = childrenArray[0];
    const baseCssClass = 'uitk-more-info-trigger';
    const childClassName = getClassNameList(baseCssClass, `${baseCssClass}-size-${size}`, `${baseCssClass}-weight-${weight}`, `${baseCssClass}-theme-${theme}`, `${baseCssClass}-align-${align}`, className);
    if (!props.onClickCapture && analytics) {
      props.onClickCapture = analyticsTracker.bind(this, analytics);
    }
    firstChild = React.cloneElement(firstChild, firstChild.props, React.Children.map(firstChild.props.children, child => {
      if (!child) {
        return;
      }
      if (React.isValidElement(child) && child.type.displayName?.match(/(EGDS|Uitk)Icon/)) {
        return jsx("div", {
          className: getClassNameList(`${baseCssClass}-icon-container`, `${baseCssClass}-size-${size}-icon-container`),
          ref: domRef,
          children: React.cloneElement(child, {
            size: 'small',
            className: getClassNameList(`${baseCssClass}-icon`, `${baseCssClass}-icon-theme-${theme}`)
          })
        });
      }
      return child;
    }));
    const decoratedChild = React.cloneElement(firstChild, {
      analytics,
      className: childClassName,
      ...props
    });
    return decoratedChild;
  }
}
export { EGDSMoreInfoTrigger };